export class ErrorBase<T extends string> extends Error {
  name: T

  constructor(name: T, error: string) {
    super(error)
    this.name = name
  }
}
